import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";

import PDFViewerImage5 from "../../../../assets/PDFViewerImages/PDFViewerImage5.jpg";

const Chapter11 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>

             {/* Chapter 11 */}
                <section id="section11" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                        {language.chapter11Title}
                    </h2>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter11Paragraph1}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter11Paragraph2}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter11Paragraph3}
                    </p>

                    <p className="drivers-handbook-paragraph">
                       {language.chapter11Paragraph4}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter11Paragraph5}
                    </p>

                    <p className="drivers-handbook-paragraph">
                       {language.chapter11Paragraph6}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter11Paragraph7}

                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter11Paragraph8}

                    </p>

                    <p className="drivers-handbook-paragraph">
                       {language.chapter11Paragraph9}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter11Paragraph10}
                    </p>

                    <p className="drivers-handbook-paragraph">
                       {language.chapter11Paragraph11}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter11Paragraph12}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter11Paragraph13}

                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter11Paragraph14}

                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter11Paragraph15}
                        නම් ඉක්මනින් මාර්ගයේ අනිත් පැත්තය පැනිය යුතුය.
                    </p>
                    <div className="image-box">
                        <img src={PDFViewerImage5} alt="Traffic Rules"/>
                    </div>


                </section>
        </>
    )

}

export default Chapter11;
